/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    ----------------------------------------------------------------
    Date         Author   Comment
    ----------------------------------------------------------------
    2023-11-28	  Khyati   This is APIs headers token
    2024-02-20    Khyati   This is APIs headers token with form-type
*/

// storing user name
const user = localStorage.getItem("user_name");
// storing access token
const accessToken = localStorage.getItem("access_token");

export default function authHeader() {
  if (user && accessToken) {
    return { Authorization: "Bearer " + accessToken };
  } else {
    return {};
  }
}

export function formDataHeader() {
  if (user && accessToken) {
    return {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "multipart/form-data",
    };
  } else {
    return {};
  }
}
